import Mithril from 'mithril';
import { extend, override } from 'flarum/common/extend';
import app from 'flarum/forum/app';

export default function () {
  const route: any = app.routes['clarkwinkelmann-group-list'];

  if (!route || !route.component) return;

  extend(route?.component.prototype, 'content', function (vnode) {
    if (!Array.isArray(vnode)) return;

    vnode.forEach((item) => {
      const description = item.children.find((e: Mithril.Vnode<any>) => e && e.tag == 'div' && e.attrs.className.includes('GroupList-description'));

      if (description) {
        delete item.children[1];
        item.children[0].children.push(description);
      }
    });
  });
}
